<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h5 class="heading-1 mb-4">
                    <span
                        >SERVIÇOS COM FATURAMENTO EM ATRASO</span
                    >
                </h5>
                <pnl-vencimentos-servicos
                :comprometimentosVencimentos="comprometimentosVencimentos"
                    @filtrar="filtrarPorVencimento"
                >
                </pnl-vencimentos-servicos>
            </b-card-body>
        </b-card>
        <b-card no-body>
            <b-card-header>
                <span class="h5">SERVIÇOS</span>
                <div class="float-right">
                    <span class="text-primary">
                        <i
                            class="fa fa-refresh fa-lg icon-button"
                            title="Atualizar"
                            @click.stop="obterComprometimentos()"
                        ></i>
                    </span>
                </div>
            </b-card-header>

            <b-card-body>
                <b-alert
                    show
                    variant="warning"
                    v-if="comprometimentoEmAnaliseNaoComprometido"
                >
                    <h5>Atenção</h5>
                    <p>
                        Os serviços só podem ser aprovados se estiverem
                        comprometidos. Procure a <strong>UABS</strong> para
                        regularizar a situação dos serviços nas situações
                        <app-status status="NÃO COMPROMETIDO"></app-status> e
                        <app-status status="EM ANÁLISE"></app-status>.
                    </p>
                </b-alert>
                <app-tabela
                    :itens="comprometimentosFiltrados"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="botoes">
                        <b-row>
                            <b-col sm="12" md="12">
                                <b-form-group class="float-right">
                                    <strong>
                                        <label>Por Status</label>
                                    </strong>
                                    <b-form-select
                                        :plain="true"
                                        :options="statusSelect"
                                        v-model="status"
                                    ></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <slot name="botoes"></slot>
                    </template>
                    <template slot="diasAtraso" slot-scope="data">{{
                        data.diasAtraso | 0
                    }}</template>
                    <template slot="valor" slot-scope="data">{{
                        data.valor | currency
                    }}</template>
                    <template slot="acoes" slot-scope="data">
                        <comprometimento-anexos
                            :comprometimento="data"
                            :dataServico="obterDataServico()"
                            :mostrarBtnInserir="mostrarBtnInserir(data)"
                            :mostrarBtnExcluir="mostrarBtnExcluir(data)"
                            @obter-atualizacao="obterComprometimentos()"
                        ></comprometimento-anexos>
                        <comprometimento-aprovadores
                            :comprometimento="data"
                            :dataServico="obterDataServico()"
                        >
                        </comprometimento-aprovadores>
                        <comprometimento-aprovar
                            v-if="mostrarBtnAprovar(data)"
                            :comprometimento="data"
                            :dataServico="obterDataServico()"
                            @obter-atualizacao="obterComprometimentos()"
                        >
                        </comprometimento-aprovar>
                        <comprometimento-reprovar
                            v-if="mostrarBtnReprovar(data)"
                            :comprometimento="data"
                            :dataServico="obterDataServico()"
                            @obter-atualizacao="obterComprometimentos()"
                        >
                        </comprometimento-reprovar>
                        <btn-justificativas-reprovacao
                            :comprometimento="data"
                        ></btn-justificativas-reprovacao>
                        <comprometimento-aprovacao
                            :comprometimento="data"
                        ></comprometimento-aprovacao>
                        <btn-comprometimento-pagamento
                            v-if="data.temPagamento"
                            :pagamentoId="data.pagamentoId"
                        ></btn-comprometimento-pagamento>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import ComprometimentoAnexos from '../comprometimentos/ComprometimentoAnexos'
import ComprometimentoReprovar from './ComprometimentoReprovar'
import ComprometimentoAprovar from './ComprometimentoAprovar'
import ComprometimentoAprovadores from '../comprometimentos/ComprometimentoAprovadores'
import AprovadoresServicos from './AprovadoresServicos.js'
import { comprometimentoStatus } from '../comprometimentos/ComprometimentoStatus'
import { comprometimentoSituacao } from '../comprometimentos/ComprometimentoSituacao'
import BtnJustificativasReprovacao from '../comprometimentos/BtnJustificativasReprovacao'
import ComprometimentoAprovacao from './ComprometimentoAprovacao'
import BtnComprometimentoPagamento from './BtnComprometimentoPagamento'
import PnlVencimentosServicos from './PnlVencimentosServicos'

export default {
    inject: {
        servicosServicos: {
            default: null
        }
    },

    data() {
        return {
            statusSelect: [
                { text: 'TODOS', value: -2 },
                { text: 'EM ABERTO', value: 0 },
                { text: 'EM ANÁLISE', value: 1 },
                { text: 'APROVADA', value: 2 },
                { text: 'REPROVADA', value: 3 }
            ],
            status: 1,
            filtroVencimento: 0, // 0 = todos, 1 = acima de 61 dias, 2 = 46-60 dias, 3 = 31-45 dias, 4 = até 30 dias
            comprometimentosVencimentos: {},
            comprometimentos: [],
            erros: [],
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações',
                    tdClass: 'text-center'
                },
                {
                    key: 'idComprometimento',
                    label: 'Id',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'nomeUnidade',
                    label: 'Unidade',
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'nomeProjeto',
                    label: 'Projeto',
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'nomeAcao',
                    label: 'Ação',
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'processo',
                    label: 'Processo',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'idRequisicao',
                    label: 'Requisição',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'contrato',
                    label: 'Contrato',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'fornecedor',
                    label: 'Fornecedor',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'tipo',
                    label: 'Tipo',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap',
                    type: 'status'
                },
                {
                    key: 'dataEmissao',
                    label: 'Data de Emissão',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-center',
                    type: 'date'
                },
                {
                    key: 'dataMovimento',
                    label: 'Data do Movimento',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-center',
                    type: 'date'
                },
                {
                    key: 'historico',
                    label: 'Histórico',
                    filterable: true
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'idRm',
                    label: 'ID RM',
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'situacao',
                    label: 'Situação',
                    type: 'status'
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    type: 'status'
                },
                {
                    key: 'qtdAnexos',
                    label: 'Qtd. Anexos'
                },
                {
                    key: 'diasAtraso',
                    label: 'Dias em Atraso',
                    tdClass: 'text-nowrap text-center',
                    sortable: true
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime',
                    tdClass: 'text-nowrap text-center'
                }
            ],
            itensPorPagina: 10
        }
    },

    methods: {
        obterComprometimentos() {
            this.$store.dispatch('addRequest')
            const servicoAUsar = this.servicosServicos || AprovadoresServicos
            servicoAUsar.obterComprometimentos().then((response) => {
                if (response) {
                    if (response.success) {
                        this.comprometimentos = response.data
                    } else {
                        this.erros = ['Erro ao obter atividades']
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
        obterComprometimentosPorVencimentos() {
            this.$store.dispatch('addRequest')
            const servicoAUsar = this.servicosServicos || AprovadoresServicos
            servicoAUsar.obterComprometimentosPorVencimentos().then((response) => {
                if (response) {
                    if (response.success) {
                        this.comprometimentosVencimentos = response.data
                    } else {
                        this.erros = ['Erro ao obter comprometimentos por prazos']
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterDataServico() {
            return this.servicosServicos || AprovadoresServicos
        },

        mostrarBtnInserir(comprometimento) {
            const permissaoServico = this.servicosServicos ? this.obterPermissaoServico() : 'GESCON-COMP-APROV-00'
            return (
                comprometimento.status == comprometimentoStatus.EM_ANALISE &&
                this.$temAcessoView(permissaoServico)
            )
        },

        mostrarBtnExcluir(comprometimento) {
            const permissaoServico = this.servicosServicos ? this.obterPermissaoServico() : 'GESCON-COMP-APROV-00'
            return (
                comprometimento.status == comprometimentoStatus.EM_ANALISE &&
                this.$temAcessoView(permissaoServico)
            )
        },

        mostrarBtnReprovar(comprometimento) {
            const permissaoServico = this.servicosServicos ? this.obterPermissaoServico() : 'GESCON-COMP-APROV-00'
            return (
                comprometimento.status == comprometimentoStatus.EM_ANALISE &&
                this.$temAcessoView(permissaoServico)
            )
        },

        mostrarBtnAprovar(comprometimento) {
            const permissaoServico = this.servicosServicos ? this.obterPermissaoServico() : 'GESCON-COMP-APROV-00'
            let anexosOk = true
            if (comprometimento.contratoTipoEspecial) {
                anexosOk = comprometimento.qtdAnexos > 0
            }
            return (
                comprometimento.status == comprometimentoStatus.EM_ANALISE &&
                anexosOk &&
                comprometimento.idRm > 0 &&
                this.$temAcessoView(permissaoServico)
            )
        },

        obterPermissaoServico() {
            // Detectar a permissão baseado na rota atual
            const rota = this.$route.path
            if (rota.includes('/gestores/')) return 'GESCON-GEST-APROV-00'
            if (rota.includes('/gerentes/')) return 'GESCON-GER-APROV-00'
            if (rota.includes('/financeiro/')) return 'GESCON-UFI-APROV-00'
            if (rota.includes('/uabs/')) return 'GESCON-UABS-SERV-00'
            return 'GESCON-COMP-APROV-00'
        },

        filtrarPorVencimento(periodo) {
            this.filtroVencimento = periodo
        },

        comprometimentoPertenceAoPeriodo(comprometimento, periodo) {
            if (!this.comprometimentosVencimentos || periodo === 0) return true
            
            let idsDosPeriodo = []
            
            switch (periodo) {
                case 1: // Acima de 61 dias
                    idsDosPeriodo = this.comprometimentosVencimentos.diasAcima61 || []
                    break
                case 2: // Entre 46 e 60 dias
                    idsDosPeriodo = this.comprometimentosVencimentos.dias46a60 || []
                    break
                case 3: // Entre 31 e 45 dias
                    idsDosPeriodo = this.comprometimentosVencimentos.dias31a45 || []
                    break
                case 4: // Até 30 dias
                    idsDosPeriodo = this.comprometimentosVencimentos.dias30 || []
                    break
                default:
                    return true
            }
            
            // Normaliza os IDs removendo o ".0" e converte para número para comparar
            const idsNormalizados = idsDosPeriodo.map(id => parseInt(String(id).replace('.0', '')))
            const idComprometimento = parseInt(comprometimento.idComprometimento)
            
            return idsNormalizados.includes(idComprometimento)
        },

        comprometimentoEstaVencidoAcima61Dias(idComprometimento) {
            if (!this.comprometimentosVencimentos || !this.comprometimentosVencimentos.diasAcima61) {
                return false
            }
            
            // Normaliza os IDs removendo o ".0" e converte para número para comparar
            const idsVencidos = this.comprometimentosVencimentos.diasAcima61.map(id => parseInt(String(id).replace('.0', '')))
            const idComprometimentoInt = parseInt(idComprometimento)
            
            return idsVencidos.includes(idComprometimentoInt)
        }
    },

    created() {
        this.obterComprometimentos()
        this.obterComprometimentosPorVencimentos()
    },

    computed: {
        comprometimentosComputados() {
            return this.comprometimentos.map(comprometimento => ({
                ...comprometimento,
                nomeProjeto: comprometimento.rateiosComprometimento && comprometimento.rateiosComprometimento.length > 0 ? comprometimento.rateiosComprometimento[0].nomeProjeto : '',
                nomeAcao: comprometimento.rateiosComprometimento && comprometimento.rateiosComprometimento.length > 0 ? comprometimento.rateiosComprometimento[0].nomeAcao : '',
                nomeUnidade: comprometimento.rateiosComprometimento && comprometimento.rateiosComprometimento.length > 0 ? comprometimento.rateiosComprometimento[0].nomeUnidade : '',
                // Colorir linha em vermelho se comprometimento está na lista de vencidos acima de 61 dias
                _rowVariant: this.comprometimentoEstaVencidoAcima61Dias(comprometimento.idComprometimento) ? 'danger' : null
            }))
        },

        comprometimentosFiltrados() {
            let filtrados = [...this.comprometimentosComputados]
            
            // Filtrar por status
            if (this.status !== -2) {
                filtrados = filtrados.filter(p => p.status === this.status)
            }
            
            // Filtrar por período de vencimento
            if (this.filtroVencimento !== 0) {
                filtrados = filtrados.filter(p => this.comprometimentoPertenceAoPeriodo(p, this.filtroVencimento))
            }
            
            return filtrados
        },

        comprometimentoEmAnaliseNaoComprometido() {
            return this.comprometimentosComputados.find(
                (p) =>
                    p.status == comprometimentoStatus.EM_ANALISE &&
                    (p.idSituacao == comprometimentoSituacao.NAO_COMPROMETIDO ||
                        p.idSituacao ==
                            comprometimentoSituacao.SEM_COMPROMETIMENTO)
            )
        }
    },

    watch: {},

    components: {
        ComprometimentoAnexos,
        ComprometimentoReprovar,
        ComprometimentoAprovadores,
        BtnJustificativasReprovacao,
        ComprometimentoAprovar,
        ComprometimentoAprovacao,
        BtnComprometimentoPagamento,
        PnlVencimentosServicos
    }
}
</script>
